import { Paragraph2 } from "@bounce/design-system"
import type { Nullable } from "@bounce/util"

import type { PNImageProps } from "../PNImage/PNImage"
import { PNImage } from "../PNImage/PNImage"

export type ItemProps = {
  title?: Nullable<React.ReactNode>
  description?: Nullable<React.ReactNode>
  src: PNImageProps["src"]
}

export const Item = ({ title, description, src }: ItemProps) => (
  <div>
    <PNImage
      src={src}
      loading="lazy"
      width={64}
      height={64}
      imgixParams={{ fit: "max", h: 64 }}
      className="size-16 object-contain object-center"
    />
    {!!title && <h3 className="title5 mt-3 text-black">{title}</h3>}
    {!!description && <Paragraph2 className="mt-3 text-neutral-800">{description}</Paragraph2>}
  </div>
)
